import React, { useEffect, useState } from 'react'
import './ValueNamesEdit.scss'
import { TdsButton, TdsIcon } from '@scania/tegel-react';
import ValueNamesEditBox from './ValueNamesEditBox/ValueNamesEditBox';
import { useFormContext } from 'react-hook-form';


type ValueNamesEditPropType = {
   valueNamesObject?: any
}
interface ValueNameObject {
   hexCode: string
   name: string
}
const ValueNamesEdit = ({ valueNamesObject }: ValueNamesEditPropType) => {

   const [valueNamesArray, setValueNamesArray] = useState<Array<ValueNameObject>>([]);
   const { setValue, watch, getValues } = useFormContext()
   const valueNameFormItemKey = "value_names"
   const valueNameItems: Array<ValueNameObject> = watch(valueNameFormItemKey, valueNamesObject) || [] as Array<ValueNameObject>

   const addValueNamesEditBox = () => {
      const valueNameItem: ValueNameObject = {} as ValueNameObject;
      valueNameItems.push(valueNameItem);
      setValue(valueNameFormItemKey, valueNameItems)
      setValueNamesArray(valueNameItems)
   }

   const removeValueNamesEditBox = (index: number) => {
      valueNameItems.splice(index, 1);
      setValue(valueNameFormItemKey, valueNameItems);
      setValueNamesArray(valueNameItems)
   };

   useEffect(() => {
      if (valueNamesObject) {

         setValue(valueNameFormItemKey, valueNamesObject);
         setValueNamesArray(valueNamesObject);

      } else {
         const valueNames = getValues(valueNameFormItemKey);
         setValueNamesArray(valueNames);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [valueNamesObject]);

   return (<>
      <div className='tds-u-flex-end'>
         <TdsButton variant="primary" size="sm" text="Add" onClick={addValueNamesEditBox}>
            <TdsIcon slot="icon" size="20px" name="plus" />
         </TdsButton>
      </div>
      {
         valueNamesArray && valueNamesArray.length > 0 ? (valueNamesArray.map((valueName, index) => (
            <ValueNamesEditBox
               key={"value-name-box-" + index}
               index={index}
               removeFunction={removeValueNamesEditBox}
            />
         ))) : (<div className='tds-container-fluid tds-u-p1'>
            <div className='tds-row'>
               <div className="tds-col-md-12 tds-u-mt1">
                  Click the add button to start adding value names.
               </div>
            </div>
         </div>)
      }
   </>
   )
}

export default ValueNamesEdit